import CommonServices from './CommonServices';
import CommonServicesMock from './CommonServicesMock';

const isMockingService = process.env.VUE_APP_MOCKING_SERVICES === 'true' || process.env.VUE_APP_MOCKING_SERVICES === true;
export default isMockingService ? CommonServicesMock : CommonServices;
